/** Priority tiers of the current network with the missions in each. */
import { useUI } from '@/state/store';
import { Chip } from '@/components/ui/primitives';
import { useLoader } from '../../store';

export function PrioritiesPanel() {
  const dataset = useLoader((s) => s.dataset);
  const select = useUI((s) => s.select);
  if (!dataset) return <div className="p-4 text-xs text-ink-3">Loading the network.</div>;
  const tiers = [...dataset.tiers].sort((a, b) => a.level - b.level);
  return (
    <div className="grid gap-2 p-panel text-data sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5">
      {tiers.map((t) => {
        const missions = dataset.missions.filter((m) => m.priorityTier === t.level);
        return (
          <div
            key={t.level}
            className="flex flex-col gap-2 rounded-panel border border-hairline bg-inset/50 p-3"
            style={{ borderTopColor: t.color ?? undefined, borderTopWidth: 2 }}
          >
            <div className="flex items-center gap-2">
              <span className="font-mono text-ink-3">T{t.level}</span>
              <span className="font-medium text-ink">{t.name}</span>
              <span className="ml-auto text-ink-3">{missions.length}</span>
            </div>
            {t.description && <p className="leading-snug text-ink-2">{t.description}</p>}
            <div className="flex flex-wrap gap-1">
              {t.canBump && <Chip tone="neutral">bumps lower</Chip>}
              {t.canBeBumped === false && <Chip tone="nominal">never bumped</Chip>}
              {t.negotiable && <Chip tone="neutral">negotiable</Chip>}
            </div>
            {missions.length > 0 && (
              <div className="flex flex-wrap gap-1">
                {missions.map((m) => (
                  <button
                    key={m.id}
                    type="button"
                    onClick={() => select({ missionId: m.id, antennaId: null, assetId: null })}
                    className="rounded-control border border-hairline px-1.5 py-0.5 text-ink-2 hover:text-ink"
                  >
                    {m.shortName}
                  </button>
                ))}
              </div>
            )}
            {t.examples && t.examples.length > 0 && <div className="text-ink-3">{t.examples.join(', ')}</div>}
          </div>
        );
      })}
    </div>
  );
}
